var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAsset35(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 265 264.51",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        stroke: #dc2c2c;\n      }\n\n      .cls-1, .cls-2, .cls-3 {\n        stroke-linecap: round;\n        stroke-linejoin: round;\n      }\n\n      .cls-1, .cls-3 {\n        fill: none;\n        stroke-width: 9px;\n      }\n\n      .cls-2 {\n        fill: #fff;\n        stroke-width: 5px;\n      }\n\n      .cls-2, .cls-3 {\n        stroke: #10519e;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_10",
    "data-name": "Layer 10"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M227.98,52.36v9.76H4.5v-9.76C4.5,25.92,25.92,4.5,52.36,4.5h127.77c26.43,0,47.86,21.42,47.86,47.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M227.98,76.12v95.71c-3.95-1.13-8.13-1.74-12.44-1.74-.22,0-.44,0-.65,0-13.15.18-24.93,6.01-33.03,15.18-7.01,7.93-11.27,18.35-11.27,29.77,0,5.58,1.01,10.92,2.88,15.84H52.36c-26.43,0-47.86-21.42-47.86-47.86v-106.92h223.48Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 22.85,
    y: 109.59,
    width: 42.44,
    height: 33.17,
    rx: 9.31,
    ry: 9.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 94.84,
    y: 109.59,
    width: 42.44,
    height: 33.17,
    rx: 9.31,
    ry: 9.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 166.83,
    y: 109.59,
    width: 42.44,
    height: 33.17,
    rx: 9.31,
    ry: 9.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 22.85,
    y: 161.49,
    width: 42.44,
    height: 33.17,
    rx: 9.31,
    ry: 9.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 95.34,
    y: 161.49,
    width: 42.44,
    height: 33.17,
    rx: 9.31,
    ry: 9.31
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M260.5,215.05c0,24.83-20.13,44.96-44.96,44.96-19.25,0-35.68-12.1-42.08-29.11-1.87-4.92-2.88-10.27-2.88-15.84,0-8.34,2.27-16.14,6.23-22.84,1.45-2.47,3.14-4.79,5.04-6.93,8.1-9.17,19.89-15,33.03-15.18.22,0,.44,0,.65,0h.22c4.23.02,8.34.63,12.22,1.74,18.78,5.4,32.52,22.71,32.52,43.22Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 215.76,
    y1: 214.61,
    x2: 215.76,
    y2: 185.54
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 247.19,
    y1: 214.61,
    x2: 215.76,
    y2: 214.61
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsset35);
export default __webpack_public_path__ + "static/media/Asset 35.e89894ec2db57a0103d115aceb4ae907.svg";
export { ForwardRef as ReactComponent };